//异常数据
import _import from '@/utils/import'
const Layout = _import('layout/Layout')
let abnormaData = [
  {
    path: '',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'cityDetail',
        component: _import('dashboard/provinceDetail'),
        name: 'cityDetail',
        meta: { 
          title: '地市详情',
          icon: 'widgets'
        }
      }
    ]
  },
  //省份-地域详情界面
  {
    path: '',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'locationDetail',
        component: _import('dashboard/locationDetail'),
        name: 'locationDetail',
        meta: { 
          title: '地市详情',
          icon: 'widgets'
        }
      }
    ]
  },
  {
    path: '',
    component: Layout,
    children: [
      {
        path: 'singleCard',
        component: _import('singleCard/index'),
        name: 'singleCard',
        meta: { 
          title: '单卡异常卡查询',
          icon: 'card'
         }
      }
    ]
  }
]
export default abnormaData;